var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#196BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09569 8.67568C6.11005 7.22703 6.69856 6.78378 7.689 6.32973C8.27751 6.05946 8.73684 5.62703 8.73684 5.02162C8.73684 4.28649 7.97608 3.82162 7.02871 3.82162C6.21053 3.82162 5.39234 4.18919 5.30622 5.07568H4C4.07177 3.76757 5.39234 3 7.02871 3C8.82297 3 10 3.87568 10 5.06486C10 5.90811 9.4689 6.5027 8.57895 6.91351C7.689 7.32432 7.35885 7.73514 7.33014 8.67568V8.72973H6.09569V8.67568ZM6.75598 11C6.25359 11 5.82297 10.6865 5.83732 10.2973C5.82297 9.91892 6.25359 9.60541 6.75598 9.60541C7.25837 9.60541 7.67464 9.91892 7.67464 10.2973C7.67464 10.6865 7.25837 11 6.75598 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.869127611a2a9a2e2d722d37f0b301c2.svg";
export { ForwardRef as ReactComponent };